import {
  FileExcelOutlined,
  FileGifOutlined,
  FileImageOutlined,
  FileJpgOutlined,
  FileMarkdownOutlined,
  FileOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  FileTextOutlined,
  FileWordOutlined,
  FileZipOutlined,
} from '@ant-design/icons';
import { FILE_ICON } from '.';

const fileIcons = {
  xlsx: FileExcelOutlined,
  docx: FileWordOutlined,
  gif: FileGifOutlined,
  png: FileImageOutlined,
  jpg: FileJpgOutlined,
  jpeg: FileJpgOutlined,
  md: FileMarkdownOutlined,
  pdf: FilePdfOutlined,
  pptx: FilePptOutlined,
  txt: FileTextOutlined,
  zip: FileZipOutlined,
  rar: FileZipOutlined,
};

export type FileIconProps = {
  /**
   * Mapped extensions: "xlsx" | "docx" | "gif" | "png" | "jpg" | "jpeg" | "md" | "pdf" | "pptx" | "txt" | "zip" | "rar".
   * Anything else — including no extension — renders the generic file icon.
   */
  ext?: string;
  /**
   * Size of icon ex: 80.
   */
  size?: number;
};

export const FileIcon = ({ ext, size = 80 }: FileIconProps) => {
  // Extensions are stored as the user's file named them, so match case-insensitively — the rest of
  // the app lowercases before comparing too.
  const normalizedExt = ext?.toLowerCase();
  // `FileOutlined` is the fallback for a format nobody mapped (and for a file with no extension at
  // all), so every file gets an icon rather than an empty gap.
  const FileIconRender =
    normalizedExt && normalizedExt in fileIcons ? fileIcons[normalizedExt as keyof typeof fileIcons] : FileOutlined;

  return <FileIconRender style={{ fontSize: size }} data-testid={FILE_ICON} title={ext} />;
};
